import React, {useEffect, useState} from 'react';
import {useTypedSelector} from "../../hooks/useTypedSelector";


function UnitAD({attack, hp, level, isSmall = false, isBigSize, isVeryBigSize, isBattle = false}: any) {

    const {cpuPlayedCard} = useTypedSelector(state => state.game);

    const [hpValue, setHpValue] = useState(-9999);
    const [delayedHp, setDelayedHp] = useState(hp);
    let hpDelayTimeOut = 1;
    if (cpuPlayedCard.card !== null) {
        hpDelayTimeOut = 1000;
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDelayedHp(hp);
        }, hpDelayTimeOut);

        return () => clearTimeout(timer);
    }, [hp]);

    let hpClasses = 'unitAD unitD unitDBG-' + level;
    let attackClasses = 'unitAD unitA unitABG-' + level;
    let containerSize = ' unitADContainerNormalSize';
    if (isBigSize) {
        hpClasses += ' unitAdBig';
        attackClasses += ' unitAdBig';
        containerSize = ' unitADContainerBigSize';
    }

    if (isVeryBigSize) {
        containerSize = ' unitADContainerVeryBigSize';
    }

    if (isSmall) {
        containerSize = ' unitADContainerSmallSize';
    }

    let hpChangeClasses = 'hpChangeAD';
    let hpChangeAnimation = '';
    let hpChangedValue = 0;
    if (hpValue !== -9999 && hpValue > delayedHp && isBattle) {
       // setTimeout(() => {

            hpChangedValue = hp - hpValue;
            hpChangeClasses += ' hpChangeADActive';
            hpChangeAnimation = 'hpChangeADAnimation font-oswald-bold  ';
            setTimeout(() => {
                setHpValue(hp);
            }, 1000);

       // }, startAnimationTimeout);
    }

    if (hpValue === -9999) {
        setHpValue(hp);
    }


    return (
        <div className={'unitADContainer font-oswald-bold unitADContainerBG-' + level + containerSize}>
            <div className={attackClasses}>
                <div className={'cardAdValue'}>{attack}</div>
            </div>
            <div className={hpClasses}>
                <div className={'cardAdValue'}>{delayedHp}</div>
            </div>
            <div className={hpChangeClasses}>
                <div className={hpChangeAnimation}>{hpChangedValue}</div>
            </div>
            <div></div>
        </div>
    );
}

export default UnitAD;
